// Minimal API client for your PHP endpoints (no auth needed)
//const BASE_URL = import.meta?.env?.VITE_API_BASE || process.env.REACT_APP_API_BASE || "http://localhost/api/";
const BASE_URL ="https://gantasoft.in/cab-g/dev/driver/v1/"
function qs(params) {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.append(k, v);
  });
  return q.toString();
}

function encodeForm(data) {
  const f = new URLSearchParams();
  Object.entries(data || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) f.append(k, v);
  });
  return f;
}

async function getJSON(url) {
  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

async function postForm(url, data) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encodeForm(data),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

/* ---- Endpoints ---- */

// 1) Drivers list
export async function listDrivers({ q = "", status = "", main_status = "", vehicle_type = "", page = 1, per_page = 10 } = {}) {
  const url = `${BASE_URL}drivers_list.php?${qs({ q, status, main_status, vehicle_type, page, per_page })}`;
  return getJSON(url); // {success, items, page, total, ...}
}

// 2) Update driver status / online / vehicle_type
export async function updateDriver({ driver_id, status, main_status, online, vehicle_type }) {
  return postForm(`${BASE_URL}driver_update_status.php`, { driver_id, status, main_status, online, vehicle_type });
}

// 3) Get driver documents
export async function getDriverDocuments(driver_id) {
  const url = `${BASE_URL}driver_documents.php?${qs({ driver_id })}`;
  return getJSON(url); // {success, driver_id, items:[...]}
}

// 4) Verify / reject / expire a document
export async function verifyDocument({ driver_id, type, action, expiry_date, note }) {
  return postForm(`${BASE_URL}verify_document.php`, { driver_id, type, action, expiry_date, note });
}
